import { IPostAudio } from "../../Post/Post.types";
import {
  AUDIO_SLIDER_CONFIG,
  AUDIO_TIME_CONSTANTS,
  POST_AUDIO_TEXTS,
} from "../constants/PostAudio.constants";

export const formatAudioTime = (seconds: number): string => {
  if (isNaN(seconds) || seconds < 0) {
    return AUDIO_TIME_CONSTANTS.DEFAULT_TIME_STRING;
  }
  const mins = Math.floor(seconds / AUDIO_TIME_CONSTANTS.SECONDS_IN_MINUTE);
  const secs = Math.floor(seconds % AUDIO_TIME_CONSTANTS.SECONDS_IN_MINUTE);
  return `${mins}:${String(secs).padStart(
    AUDIO_TIME_CONSTANTS.PAD_LENGTH,
    "0",
  )}`;
};

export const getAudioTitle = (audio: IPostAudio, index: number): string => {
  if (audio.name) return audio.name;
  const fileNameFromUrl = audio.url.split("/").pop()?.split("?")[0];
  if (fileNameFromUrl) return fileNameFromUrl;
  return `${POST_AUDIO_TEXTS.DEFAULT_TITLE_PREFIX} ${index + 1}`;
};

export const calculateProgressPercent = (
  currentTime: number,
  duration: number,
): number => {
  if (!duration || duration <= 0) return 0;
  return (currentTime / duration) * AUDIO_SLIDER_CONFIG.PERCENTAGE_MAX;
};

export const checkIsVoiceRecording = (audioName?: string): boolean => {
  if (!audioName) return false;
  return audioName.toLowerCase().includes(POST_AUDIO_TEXTS.RECORD_KEYWORD);
};
